"use strict";
import { __exports as n } from "./index.es483.js";
import { __require as a } from "./index.es452.js";
var o;
function _() {
  return o ? n : (o = 1, (function(r) {
    Object.defineProperty(r, "__esModule", {
      value: !0
    }), Object.defineProperty(r, "isDynamicRoute", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const i = a(), u = /\/[^/]*\[[^/]+\][^/]*(?=\/|$)/, c = /\/\[[^/]+\](?=\/|$)/;
    function s(e, t) {
      return t === void 0 && (t = !0), (0, i.isInterceptionRouteAppPath)(e) && (e = (0, i.extractInterceptionRouteInformation)(e).interceptedRoute), t ? c.test(e) : u.test(e);
    }
  })(n), n);
}
export {
  _ as __require
};
//# sourceMappingURL=index.es448.js.map
